<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <Loader :loading="loading"></Loader>
            <section class="zone-groups">
                <div class="row">
                    <div class="col-12 col-sm-3">
                        <div class="row">
                            <div class="col zone-header">
                                <h1 class="zone-groups-title">{{ $t("zoneGroups.title") }}</h1>

                                <input type="text" id="searchBySearch" class="rem3rch-input-text" v-model="search" />
                                <label for="searchBySearch" class="m-0 pointer ml-3"><i class="fa fa-search fa-lg color-grey"></i></label>

                                <button @click="openModalCreateZoneGroup()" class="btn zone-groups-btn-add my-5">
                                    <i class="fa fa-plus fa-xs"></i> <span class="ml-2">{{ $t("zoneGroups.add") }}</span>
                                </button>

                                <div
                                    v-if="brandHasZoneGroupsFiltered.length && currentBrandHasZoneGroup"
                                    v-for="brandHasZoneGroup in brandHasZoneGroupsFiltered"
                                    :key="brandHasZoneGroup.id"
                                >
                                    <div class="row d-flex align-items-center mb-4">
                                        <div
                                            class="col zone-groups-card pointer"
                                            @click="changeBrandHasZoneGroup(brandHasZoneGroup)"
                                            :class="currentBrandHasZoneGroup.id === brandHasZoneGroup.id ? 'active' : ''"
                                        >
                                            {{ brandHasZoneGroup.zoneGroups.name }}
                                        </div>
                                        <div class="col-auto">
                                            <ClientColorButton
                                                background-color="#000"
                                                @click="openModalDeleteZoneGroup(brandHasZoneGroup)"
                                                :rounded="true"
                                                :disabled="brandHasZoneGroup.zoneGroups.countBrandZones > 0"
                                                :inactive-color="brandHasZoneGroup.zoneGroups.countBrandZones > 0"
                                            >
                                                <span>{{ $t("zoneGroups.deleteGroup") }}</span>
                                            </ClientColorButton>
                                        </div>
                                    </div>
                                </div>

                                <CreateZoneGroups
                                    v-if="paramsModalCreateZoneGroup"
                                    :params="paramsModalCreateZoneGroup"
                                    @success="reloadAndSelectNewGroup()"
                                    @close="clearParamsModal()"
                                ></CreateZoneGroups>
                                <DeleteZoneGroups
                                    v-if="paramsModalDeleteZoneGroup"
                                    :params="paramsModalDeleteZoneGroup"
                                    @success="
                                        loadBrandHadZoneGroups();
                                        clearParamsModal();
                                    "
                                ></DeleteZoneGroups>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm" style="min-width: 0" v-if="currentBrandHasZoneGroup && brandZones.length">
                        <div>
                            <b-tabs class="w-100">
                                <b-tab :title="$t('zoneGroups.zonesForRight')" v-if="currentBrandHasZoneGroup.forRight">
                                    <ZoneGroupsTab
                                        :brand-zones="brandZones"
                                        :brand-has-zone-groups="currentBrandHasZoneGroup"
                                        for="right"
                                        copy-to="dashboard"
                                        @reload="loadBrandZones"
                                    ></ZoneGroupsTab>
                                </b-tab>
                                <b-tab :title="$t('zoneGroups.zonesForDashboard')" v-if="currentBrandHasZoneGroup.forDashboard">
                                    <ZoneGroupsTab
                                        :brand-zones="brandZones"
                                        :brand-has-zone-groups="currentBrandHasZoneGroup"
                                        for="dashboard"
                                        copy-to="right"
                                        @reload="loadBrandZones"
                                    ></ZoneGroupsTab>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/loader/loader";
import ZoneGroupsTable from "@/components/admin/zoneGroups/ZoneGroupsTable";
import ZoneGroupsTab from "@/components/admin/zoneGroups/ZoneGroupsTab";
import CreateZone from "@/components/admin/zone/CreateZone";
import CreateZoneGroups from "@/components/admin/zoneGroups/CreateZoneGroups";
import brandHasZoneGroupService from "@/services/brandHasZoneGroup";
import DeleteZoneGroups from "@/components/admin/zoneGroups/DeleteZoneGroups";

export default {
    components: {
        DeleteZoneGroups,
        CreateZoneGroups,
        CreateZone,
        ZoneGroupsTab,
        ZoneGroupsTable,
        Loader
    },
    data: () => ({
        loading: true,
        search: "",
        isOpenModal: false,
        brandHasZoneGroups: [],
        currentBrandHasZoneGroup: null,
        paramsModalCreateZoneGroup: null,
        paramsModalDeleteZoneGroup: null
    }),
    computed: {
        ...mapGetters({ getBrand: "brand/getBrand" }),
        ...mapGetters("forecast", { brandZones: "getAdminBrandZones" }),
        brandHasZoneGroupsFiltered() {
            return this.brandHasZoneGroups.filter(bhzg => {
                return this.search === "" || bhzg.zoneGroups.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        }
    },
    methods: {
        ...mapActions("forecast", { populateAdminBrandZones: "populateAdminBrandZones" }),
        openModalCreateZoneGroup() {
            this.paramsModalCreateZoneGroup = {
                isActive: true
            };
        },
        openModalDeleteZoneGroup(brandHasZoneGroup) {
            this.paramsModalDeleteZoneGroup = {
                brandHasZoneGroup: brandHasZoneGroup,
                isActive: true
            };
        },
        async loadBrandZones() {
            await this.populateAdminBrandZones({ reload: true });
        },
        async loadBrandHadZoneGroups() {
            this.brandHasZoneGroups = await brandHasZoneGroupService.getAllByBrand();
            this.orderBrandHasZoneGroups();
            if (this.brandHasZoneGroups.length) {
                this.currentBrandHasZoneGroup = this.brandHasZoneGroups[0];
            }
        },
        changeBrandHasZoneGroup(brandHasZoneGroups) {
            this.currentBrandHasZoneGroup = brandHasZoneGroups;
        },
        async reloadAndSelectNewGroup(zoneGroupId) {
            await this.loadBrandHadZoneGroups();
            const brandHasZoneGroups = this.brandHasZoneGroups.find(bhzg => bhzg.zoneGroups.id === zoneGroupId);
            if (brandHasZoneGroups) {
                this.changeBrandHasZoneGroup(brandHasZoneGroups);
            }
        },
        orderBrandHasZoneGroups() {
            this.brandHasZoneGroups.sort((bhzg1, bhzg2) => {
                return bhzg1.zoneGroups.name.toLowerCase() > bhzg2.zoneGroups.name.toLowerCase() ? 1 : -1;
            });
        },
        clearParamsModal() {
            this.paramsModalCreateZoneGroup = null;
            this.paramsModalDeleteZoneGroup = null;
        }
    },
    async created() {
        await this.loadBrandZones();
        await this.loadBrandHadZoneGroups();
        this.loading = false;
    }
};
</script>

<style lang="scss">
.zone-groups {
    background-color: #fff;
    padding: 30px;
    &-title {
        color: #6f6f6f;
        font-size: 30px;
        text-transform: uppercase;
        font-family: "Oswald", sans-serif;
        font-weight: normal;
        display: block;
        margin-bottom: 40px;
    }
    &-card {
        text-align: center;
        padding: 10px 25px;
        font-size: 20px;
        font-family: "Oswald", sans-serif;
        background-color: #f4f4f4;
        box-shadow: 0 0 3px 1px #656565;
        &:hover,
        &.active {
            box-shadow: 0 0 1px 1px #656565;
        }
    }
    &-btn-add,
    &-btn-delete,
    &-btn-switch {
        display: block;
        padding: 10px 25px;
        background-color: #000;
        color: #fff;
        span {
            text-transform: uppercase;
            font-size: 14px !important;
            font-family: "Roboto", sans-serif;
        }
        &:hover {
            color: #fff;
        }
    }
    .tabs {
        .nav-tabs {
            .nav-item {
                a {
                    position: relative;
                    color: #111;
                    font-size: 18px;
                    font-weight: normal;
                    text-transform: initial;
                    border: #6f6f6f solid 2px;
                    border-bottom: none;
                    background-color: #e9ecef;
                    &.active {
                        background-color: #fff;
                        &:before {
                            content: "";
                            position: absolute;
                            width: 100%;
                            background-color: #fff;
                            left: 0;
                            bottom: -2px;
                            height: 2px;
                        }
                    }
                }
                &:not(:first-child) {
                    a {
                        border-left: none;
                    }
                }
            }
        }
        .tab-content {
            padding: 20px;
            border: #6f6f6f solid 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ZoneGroups.vue?6282c9b2